<template>
  <div id="across-shipping-cost">
    <p class="text-size-20">ACROSS倉庫から出荷した商品に対する費用明細を確認いただけます。</p>
    <div class="panel-body">
      <expense-detail-table
        :url="'/Warehouse/across/expense/shipping-cost'"
        :extraUrl="[]"
        :method="'get'"
        :clientMode="false"
        :columns="$options.columns"
        :isSearchable="true"
        :searchValue="keyword"
        :paginationStorageKey="'acrossShippingCost'"
        @countData="countData = $event"
        :needExtraData="true"
        @extraData="extraData = $event"
        @keyword="onHandleSearch"
        @confirmDownloadCsv="openModalConfirmDownloadCsv"
        ref="acrossShippingCostTable"
      >
        <template slot="shippingDate" slot-scope="props">
          <span>{{ formatDate(props.rowData.shippingDate) }}</span>
        </template>
        <template slot="detail" slot-scope="props">
          <div v-html="props.rowData.detail" class="mr-r-5"></div>
        </template>
        <template slot="size" slot-scope="props">
          <span>{{ props.rowData.size }}</span>
        </template>
        <template slot="costNoTax" slot-scope="props">
          <span>{{ formatAmount(props.rowData.costNoTax) }}</span>
        </template>
        <template slot="cost" slot-scope="props">
          <span>{{ formatAmount(props.rowData.cost) }}</span>
        </template>
      </expense-detail-table>

      <modal-confirm-download-csv
        v-if="showModalConfirmDownloadCsv"
        :message="`費用明細（出荷実績）CSVをダウンロードします。<br> よろしければ「ダウンロード」ボタンを押してください。`"
        @close="closeModalConfirmDownloadCsv"
        @downloadCsv="handleDownloadCsv"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ExpenseDetailTable from './components/ExpenseDetailTable.vue'
import Util from '@/common/utility'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import ModalConfirmDownloadCsv from '@/view/deliveryRequests/components/ModalConfirmDownloadCsv.vue'
import WarehouseAcrossService from '@/services/warehouseacrossservice'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    ExpenseDetailTable,
    ModalConfirmDownloadCsv
  },
  data () {
    return {
      keyword: null,
      search: null,
      showModalConfirmDownloadCsv: false,
      filters: {
        detail: null,
        from: null,
        to: null
      }
    }
  },
  columns: [
    {
      title: '出荷確定日時',
      name: 'shippingDate',
      cellClass: '',
      headerClass: 'text-center w-200'
    },
    {
      title: '明細',
      name: 'detail',
      cellClass: '',
      headerClass: 'text-center header-detail'
    },
    {
      title: '配送サイズ',
      name: 'size',
      cellClass: '',
      headerClass: 'text-center w-150'
    },
    {
      title: '運賃等合計(税抜)',
      name: 'costNoTax',
      cellClass: 'text-right',
      headerClass: 'text-center w-150'
    },
    {
      title: '運賃等合計(税込)',
      name: 'cost',
      cellClass: 'text-right',
      headerClass: 'text-center w-150'
    }
  ],
  mounted () {
    let logParams = {
      name: eventCode.warehouse_across.expense_details_tab.shipping_cost.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)

    let self = this
    this.$events.listen('apiSuccess', (url) => {
      if (url === '/Warehouse/across/expense/shipping-cost') {
        self.loader && self.loader.hide()
      }
    })
  },
  methods: {
    formatAmount (value) {
      return `¥${Util.formatMoney(value)}`
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD HH:mm:ss') : null
    },
    onHandleSearch (keyword) {
      let logParams = {
        name: eventCode.warehouse_across.expense_details_tab.shipping_cost.click_search_btn,
        properties: keyword
      }
      EventService.postTrackLog(logParams)

      this.filters = keyword
    },
    async handleDownloadCsv () {
      let logParams = {
        name: eventCode.warehouse_across.expense_details_tab.shipping_cost.click_download_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      let sellerId = this.$store.getters.getUser.sellerId
      let reportTime = moment(new Date()).format('YYYYMMDDHHmmss')
      let filename = `acrossWarehouse_shippingCost_${sellerId}_${reportTime}.csv`
      let params = {
        sellerId: sellerId,
        detail: this.filters.detail,
        from: this.filters.from,
        to: this.filters.to,
        costType: 'shippingCost'
      }

      this.closeModalConfirmDownloadCsv()
      await WarehouseAcrossService.exportShippingCost(params, filename)
        .then(response => {
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    openModalConfirmDownloadCsv () {
      this.showModalConfirmDownloadCsv = true
    },
    closeModalConfirmDownloadCsv () {
      $('#confirm-download-cvs-modal').modal('hide')
      this.showModalConfirmDownloadCsv = false
    }
  }
}
</script>

<style scoped>
  #across-shipping-cost /deep/ .panel-body {
    background-color: #fff;
    border: 1px solid #ccc;
  }
@media (max-width: 1200px) {
  #across-shipping-cost /deep/ .table-wrapper {
    width: 100%;
    overflow-y: hidden;
    overflow-x: auto;
  }
  #across-shipping-cost /deep/ .table {
    width: max-content;
    max-width: max-content;
  }
  #across-shipping-cost /deep/ .header-detail {
    width: 500px;
  }
  #across-shipping-cost /deep/ .box-base-table-search {
    display: block;
    justify-content: unset;
    align-items: unset;
    flex-wrap: unset;
  }
  #across-shipping-cost /deep/ .box-base-table-search .sale-detail-search {
    display: block;
  }
  #across-shipping-cost /deep/ .box-base-table-search .search-block {
    display: block;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/ShippingCost.vue